import { useEffect, useState } from "react";
import { useApiClient } from "~/context/api-client.tsx";
import getPromoBannerSettingsQuery from "~/api/get-promo-banner-settings-query.api.graphql";
import type {
	GetPromoBannerSettingsQuery,
	GetPromoBannerSettingsQueryVariables,
} from "~/api/get-promo-banner-settings-query.api.generated.ts";

type PromoBannerSettings = {
	isActive: boolean;
	htmlContent: string;
} | null;

export function usePromoBannerSettings(): PromoBannerSettings {
	const apiClient = useApiClient();
	const [settings, setSettings] = useState<PromoBannerSettings>(null);

	useEffect(() => {
		const fetchSettings = async () => {
			try {
				const result = await apiClient.request<
					GetPromoBannerSettingsQuery,
					GetPromoBannerSettingsQueryVariables
				>(getPromoBannerSettingsQuery, {});

				if (result.promoBannerSettings?.isActive) {
					setSettings({
						isActive: result.promoBannerSettings.isActive,
						htmlContent: result.promoBannerSettings.htmlContent,
					});
				} else {
					setSettings(null);
				}
			} catch (error) {
				console.error("Failed to fetch promo banner settings:", error);
				setSettings(null);
				throw error;
			}
		};

		fetchSettings();
	}, [apiClient]);

	return settings;
}
